import * as amplitude from '@amplitude/analytics-browser';


export default amplitude